"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.Reducer = void 0;
var compactor_1 = require("./compactor");
var ReducerCompactable = /** @class */ (function (_super) {
    __extends(ReducerCompactable, _super);
    function ReducerCompactable(reducer, initState) {
        var _this = _super.call(this) || this;
        _this.reducer = reducer;
        _this.initState = initState;
        _this.optimistic = true;
        return _this;
    }
    ReducerCompactable.prototype.applyAction = function (state, action) {
        return this.reducer(state, action);
    };
    ReducerCompactable.prototype.initialState = function () {
        return this.initState;
    };
    return ReducerCompactable;
}(compactor_1.Compactable));
var Reducer = /** @class */ (function () {
    function Reducer(opts) {
        var compactable = new ReducerCompactable(opts.reducer, opts.initialValue);
        this.compactor = new compactor_1.Compactor({
            key: opts.key,
            compactable: compactable,
            sizeThreshold: opts.sizeThreshold,
            db: opts.db,
            callback: opts.callback
        });
        this.dispatch = this.dispatch.bind(this);
    }
    Reducer.prototype.subscribe = function () {
        this.compactor.subscribe();
    };
    Reducer.prototype.destroy = function () {
        this.compactor.destroy();
    };
    Reducer.prototype.dispatch = function (action) {
        this.compactor.dispatch(action);
    };
    return Reducer;
}());
exports.Reducer = Reducer;
